import HeaderReportInfo from './HeaderReportInfo';

export default HeaderReportInfo;
